import AddSharpIcon from "@mui/icons-material/AddSharp";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PaymentIcon from "@mui/icons-material/Payment";
import PrintIcon from "@mui/icons-material/Print";
import {
  Box,
  ButtonBase,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { formatCurrency } from "../../utils/currency";
import "./TableCard.css";
import useMinutesAgo from "../../utils/useMinutesAgo";
import { getOrderTableStatus } from "../../constants/enums";

function TableCard({
  table,
  dineName,
  dineId,
  onTableClick,
  onPayClick,
  onPrintClick,
  onCancelClick,
  onHoldClick,
  onQuickViewClick,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const order = table?.order;
  const createdAt = order?.created_at;
  const minutesAgo = useMinutesAgo(createdAt);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const bgColor = getOrderTableStatus(table?.order_dine_table_status_id);

  return (
    <>
      <Box className="table-one-wrap">
        <Box
          style={{
            position: "relative",
            backgroundColor: bgColor?.color,
          }}
          className="table-t"
        >
          {/* <IconButton
            size="small"
            sx={{ position: "absolute", top: 5, right: 5 }}
            onClick={(e) => {
              e.stopPropagation();
              handleMenuClick(e);
            }}
          >
            <MoreVertIcon fontSize="small" />
          </IconButton> */}

          {/* <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
            <MenuItem
              onClick={() => {
                onQuickViewClick(table);
                handleMenuClose();
              }}
            >
              Quick View
            </MenuItem>
            <MenuItem
              onClick={() => {
                onHoldClick(table);
                handleMenuClose();
              }}
            >
              Hold Order
            </MenuItem>
            <MenuItem
              onClick={() => {
                onCancelClick(table);
                handleMenuClose();
              }}
            >
              Cancel Order
            </MenuItem>
          </Menu> */}

          <Box className="table-table-no">
            <Tooltip
              title={`Table: ${table.table_name} (${table.chairs} chairs)`}
              placement="top"
            >
              <Box component="span">{table.table_name}</Box>
            </Tooltip>
          </Box>

          <ButtonBase
            sx={{ display: "block", width: "100%", height: "100%" }}
            onClick={() => onTableClick({ ...table, dineName, dineId })}
          >
            {order && order?.order_id && (
              <Box>
                <Typography
                  variant="body2"
                  sx={{
                    textAlign: "center",
                    fontWeight: 500,
                    fontSize: 12,
                  }}
                >
                  {minutesAgo}
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{ textAlign: "center", fontWeight: 700 }}
                >
                  {order.total_amount && formatCurrency(order.total_amount)}
                </Typography>
              </Box>
            )}
          </ButtonBase>
          {order && order?.order_id && (
            <Box className="order-action-icons">
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  justifyContent: "center",
                  mt: 1,
                }}
              >
                <Tooltip title="Add More Items">
                  <IconButton
                    size="small"
                    sx={{
                      background: "#fff",
                    }}
                    onClick={() => onTableClick({ ...table, dineName, dineId })}
                  >
                    <AddSharpIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Print Bill">
                  <IconButton
                    size="small"
                    sx={{
                      background: "#fff",
                    }}
                    onClick={() => onPrintClick({ ...table, dineName, dineId })}
                  >
                    <PrintIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Pay / Checkout">
                  <IconButton
                    size="small"
                    sx={{
                      background: "#fff",
                    }}
                    onClick={() => onPayClick({ ...table, dineName, dineId })}
                  >
                    <PaymentIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
}

export default TableCard;
